var ProvadorCore = {
  init: function(config) {
    this.config = config;

    // Wait for DOM
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.boot());
    } else {
      this.boot();
    }
  },

  boot: function() {
    if(!window.ProvadorUI || !window.ProvadorMath || !window.ProvadorStorage) {
      console.warn("Provador Virtual: Modules missing. Ensure UI, Math and Storage are loaded.");
      return;
    }

    ProvadorUI.init(this.config);
    
    // Auto-fill from local storage
    const savedData = ProvadorStorage.getProfile();
    if (savedData) {
      ProvadorUI.populateForm(savedData);
    }
  },

  handleCalculate: function() {
    const w = parseFloat(ProvadorUI.elements.inputPeso.value);
    const h = parseFloat(ProvadorUI.elements.inputAltura.value);
    const age = parseInt(ProvadorUI.elements.inputIdade.value, 10);
    
    const activeBodyBtn = document.querySelector('.pv-btn-body-type.active');
    const bodyType = activeBodyBtn ? activeBodyBtn.getAttribute('data-body') : 'padrao';

    const activeFitBtn = document.querySelector('.pv-btn-fit.active');
    const fitPref = activeFitBtn ? activeFitBtn.getAttribute('data-fit') : 'regular';

    // Validation
    if(!w || !h || !age || isNaN(w) || isNaN(h) || isNaN(age)) return;

    // Save profile to storage
    ProvadorStorage.saveProfile({
      weight: w,
      height: h,
      age: age,
      bodyType: bodyType,
      fit: fitPref
    });

    ProvadorUI.showLoading(() => {
      // 1. Parse from description if not yet parsed
      if (this.config.descriptionText && !this.config.parsedChart) {
        if(window.ProvadorMath && ProvadorMath.extractSizeChartFromText) {
          this.config.parsedChart = ProvadorMath.extractSizeChartFromText(this.config.descriptionText);
        }
      }
      // Use parsed chart if valid
      if (this.config.parsedChart && Object.keys(this.config.parsedChart).length > 0) {
        this.config.sizeChart = this.config.parsedChart;
      }

      const result = ProvadorMath.calculateFit(w, h, age, bodyType, fitPref, this.config);
      
      // Push to DataLayer
      this.pushDataLayer(w, h, age, bodyType, fitPref, result.recommendedSize);

      // Show Results
      ProvadorUI.showResult(result);
    });
  },

  pushDataLayer: function(weight, height, age, bodyType, fitPref, recommendedSize) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'virtual_fitting_room_calculated',
      virtualFittingRoom: {
        weight: weight,
        height: height,
        age: age,
        bodyType: bodyType,
        fitPreference: fitPref,
        recommendedSize: recommendedSize,
        productHandle: this.config.productHandle,
        productTags: this.config.tags
      }
    });
  }
};

window.ProvadorCore = ProvadorCore;

// Auto-init if config object exists globally
if (window.ProvadorConfig) {
  ProvadorCore.init(window.ProvadorConfig);
}
